/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const contractLawDetailsStyles = {
  container: {
    padding: "0.25rem 1rem 1rem",
  },
  headlineContainer: {
    margin: "2rem 0 2rem 0",
    justifyContent: "center",
  },
  boxHeadingData: {
    textAlign: "center",
    color: "text.primary",
    fontWeight: 400,
  },
  subheader: {
    marginTop: "40px",
  },
  divider: {
    backgroundColor: "#cdcdcd",
    width: "100%",
    height: "1px",
    margin: "10px 0",
  },
  label: (theme: Theme) => ({
    fontWeight: 400,
    paddingTop: "16px",
    [theme.breakpoints.up("md")]: {
      paddingRight: "8px",
    },
  }),
  buttonShowMore: {
    marginTop: "2rem",
  },
};

export default contractLawDetailsStyles;
